import React, { Component } from 'react'


class Modal extends Component {

    render() {
        const { title, children, visible } = this.props
        const isActive = visible ? ' is-active' : ''

        return (
            <div className={"modal" + isActive}>
                <div className="modal-background"></div>
                <div className="modal-card">
                    <header className="modal-card-head">
                        <p className="modal-card-title">{title}</p>
                    </header>
                    <section className="modal-card-body">
                        {children}
                    </section>
                </div>
            </div>
        )
    }
}

export default Modal


// WEBPACK FOOTER //
// ./src/acervo/components/UI/Modal/Modal.js